import React from 'react'

type TagIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const TagIcon = ({ width = 20, height = 20, className, color = 'currentColor' }: TagIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.17851 6.1806H6.18684M17.5035 11.5223L11.5285 17.4973C11.3737 17.6522 11.1899 17.7752 10.9876 17.859C10.7852 17.9429 10.5684 17.9861 10.3493 17.9861C10.1303 17.9861 9.91344 17.9429 9.71111 17.859C9.50878 17.7752 9.32496 17.6522 9.17017 17.4973L2.01184 10.3473V2.01393H10.3452L17.5035 9.17226C17.8139 9.48453 17.9882 9.90695 17.9882 10.3473C17.9882 10.7876 17.8139 11.21 17.5035 11.5223Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
